__turbopack_context__.v({
  "button": "pagination-module-scss-module__vBSxqW__button",
  "forwardButton": "pagination-module-scss-module__vBSxqW__forwardButton",
  "wrapper": "pagination-module-scss-module__vBSxqW__wrapper",
});
